import React, { Component } from 'react';

export class Footer extends Component {
    static displayName = Footer.name;
    

  render () {
    return (
        <footer className="footer bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 h-100 text-center text-lg-left my-auto">
                        <ul className="list-inline mb-2">
                            <li className="list-inline-item">
                                <img src='/branding/Circle of Life - Logo No Text.png' alt='Circle of Life' width='50px' height='50px' className="mr-2" />
                                CLP Technologies
                            </li>
                            <li className="list-inline-item">&sdot;</li>
                            <li className="list-inline-item">
                                <a href="#">Privacy Policy</a>
                            </li>
                            <li className="list-inline-item">&sdot;</li>
                            <li className="list-inline-item">
                                <a href="#">Terms of Use</a>
                            </li>
                        </ul>
                        <p className="text-muted small mb-2 mb-lg-0 my-4">&copy; Circle of Life 2021. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </footer>

    );
  }
}
